<template lang="pug">
  .av-player

    //audio(ref="audio")
      source(src="~assets/scenes/scene1adults.txt" type="audio/mpeg")
    //h2 {{currTime}}



</template>

<script>
import SoundService from 'src/services/SoundService'
import AnalyticsService from '@/services/AnalyticsService'
import Raf from 'src/helpers/Raf'
import WechatService from 'src/services/WechatService'
import Subtitles from 'src/components/vca/widgets/Subtitles'
import * as MODES from 'src/config/modes'
import { mapState } from 'vuex'
export default {
  name: 'audio-player',
  components: {
    Subtitles
  },
  data() {
    return {

      paused: true,
      MODES,
      currTime:0,
      sound: null,
      vids: [],
      soundMark: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
      ],
      gtags: [
        'yosemite',
        'redwoods',
        'santabarbara',
        'montereybay',
        'lajolla'
      ],
      playAfter: false

    }
  },
  props: {


  },
  computed: {
    ...mapState('browser', ['isWechat']),
    ...mapState('app', ['mode', 'currSceneIdx', 'muted', 'showGallery', 'showMenu', 'showSubtitles', 'modeSwitching']),
  },
  mounted() {


    window.AVPlayer = this



    let idx = ''
    if(this.mode === MODES.KIDS){
      idx = `scene${this.currSceneIdx+1}kids`
    }else{
      idx = `scene${this.currSceneIdx+1}adults`
    }

    //console.log(SoundService)

    this.sound = SoundService.get(idx)
    this.sound.muted = this.muted
    this.sound.play()

    if (this.isWechat){
      if (typeof window.WeixinJSBridge == 'object' && typeof window.WeixinJSBridge.invoke == 'function') {
        //that.sound.play()
        WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
          //this.sound.muted = true
          //this.audio.play()
          this.sound.play()


        }, false);
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', ()=>{
            this.sound.play()
          }, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', ()=>{
            this.sound.play()
          })
          document.attachEvent('onWeixinJSBridgeReady', ()=>{
            this.sound.play()
          })
        }
      }
    }

    this.sound.on('end', () => {
      this.end()
    })

    this.wechatAutoplay()
    document.addEventListener('visibilitychange', this.visibilityHandler)


  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.visibilityHandler)
  },
  methods: {

    stop(){
      if (this.sound) this.sound.pause()
      let spine = document.getElementById('spinePlayer')
      if (spine){
        spine.components['spine'].pause()
        //console.log(spine, 'stop!!!!!!!!')
      }
    },
    resume(){
      if (this.showGallery || this.showMenu || this.muted) return
      if (this.sound){
        this.sound.muted = this.muted
        this.sound.play()
      }
      let spine = document.getElementById('spinePlayer')
      if (spine){
        spine.components['spine'].play()
        //console.log(spine, 'resume!!!!!!!!')
      }
    },
    visibilityHandler(){
      if (document.visibilityState === 'hidden') {
        this.stop()
      } else {
        this.resume()
      }
    },

    wechatAutoplay(){
      if (this.isWechat){
        if (typeof window.WeixinJSBridge == 'object' && typeof window.WeixinJSBridge.invoke == 'function') {
          //that.sound.play()
          WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
            //this.sound.muted = true
            //this.audio.play()
            this.sound.play()

          }, false);
        } else {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', ()=>{
              this.sound.play()
            }, false)
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', ()=>{
              this.sound.play()
            })
            document.attachEvent('onWeixinJSBridgeReady', ()=>{
              this.sound.play()
            })
          }
        }
      }
    },

    update() {
      if (!this.sound) return
      this.currTime = this.sound.currentTime

    },
    end(){
      console.log('end')
      let idx = this.currSceneIdx
      this.currTime = 0
      //if (this.soundMark[this.mode][idx]) return
      this.soundMark[this.mode][idx] = 1
      let sum = 0
      for (let i=0;i<5;i++){
        sum += this.soundMark[this.mode][i]
      }
      if (sum === 5){
        AnalyticsService.sendEvent('scene', 'complete', `${this.mode === MODES.KIDS? 'kids': 'adults'}`)
        this.$emit('end')
      } else{
        while (this.soundMark[this.mode][idx]) {
          if (idx === 4) idx=0
          else idx++
        }
        AnalyticsService.sendEvent('scene', 'finish', `0${idx+1}-${this.gtags[idx]}-${this.mode === MODES.KIDS? 'kids': 'adults'}`)
        this.$emit('next', idx)
      }

    },

    playSoundFromStart(mode, id){
      if (id === 5) {
        if (this.sound) this.sound.pause()
        return
      }
      if (this.showMenu || this.showGallery) {
        this.playAfter = true
        return
      }

      let idx = ''
      if(mode === MODES.KIDS){
        idx = `scene${id+1}kids`
      }else{
        idx = `scene${id+1}adults`
      }
      if (this.sound) this.sound.pause()
      this.sound = SoundService.get(idx)
      this.sound.currentTime = 0
      this.sound.on('end', () => {
        this.end()
      })
      if (this.muted){
        this.sound.muted = true
      } else {
        this.sound.muted = false
      }
      let spine = document.getElementById('spinePlayer')
      if (spine){
        spine.components['spine'].replay()
        spine.components['spine'].play1()
      }
      this.sound.play()
    },

    stopPlay(mode, id){
      if (id === 5) {
        if (this.sound) this.sound.pause()
        this.sound.currentTime = 0
        return
      }
      let idx = ''
      if(mode === MODES.KIDS){
        idx = `scene${id+1}kids`
        //console.log('stopplay')
        let spine = document.getElementById('spinePlayer')
        if (spine){
          //spine.components['spine'].replay()
          spine.components['spine'].pause1()
          //spine.components['spine'].replay()
        }
      }else{
        idx = `scene${id+1}adults`
      }
      if (this.sound) this.sound.pause()
      this.sound.currentTime = 0




    },



    // playVidFromStart(id){
    //   let idx = `anime${id+1}`
    //   if (this.vid) this.vid.pause()
    //   this.vid = document.getElementById(idx)
    //   this.vid.currentTime = 0
    //   this.vid.play()
    // },
    soundReplay(){
      this.playSoundFromStart(this.mode, this.currSceneIdx)
      let spine = document.getElementById('spinePlayer')
      if (spine){
        spine.components['spine'].replay()
      }
        //console.log('ppppppppppppp', spine.components['spine'])
    }

  },
  watch: {
    modeSwitching(val){
      if (val) {
        if (this.sound) this.sound.pause()
        //if (this.vid) this.vid.pause()
      }
    },
    showMenu(val){
      // if (val){
      //   if (this.sound) this.sound.pause()
      //   //if (this.vid) this.vid.pause()
      //
      // } else{
      //   if (this.playAfter) {
      //     this.playSoundFromStart(this.mode, this.currSceneIdx)
      //     this.playAfter = false
      //     return
      //   }
      //   if (this.sound) this.sound.play()
      //   //if (this.vid) this.vid.play()
      //
      // }

      if (val){
        if (this.sound) this.sound.pause()
        //if (this.vid) this.vid.pause()
        let spine = document.getElementById('spinePlayer')
        if (spine){
          spine.components['spine'].pause()
        }
      } else{
        if (this.playAfter) {
          this.playSoundFromStart(this.mode, this.currSceneIdx)
          let spine = document.getElementById('spinePlayer')
          if (spine){
            spine.components['spine'].play()
          }
          this.playAfter = false
          return
        }

        if (this.sound) this.sound.play()
        //if (this.vid) this.vid.play()
        let spine = document.getElementById('spinePlayer')
        if (spine){
          spine.components['spine'].play()
        }
      }
    },
    showGallery(val){
      if (val){
        if (this.sound) this.sound.pause()
        //if (this.vid) this.vid.pause()
        let spine = document.getElementById('spinePlayer')
        if (spine){
          spine.components['spine'].pause()
        }
      } else{
        if (this.playAfter) {
          this.playSoundFromStart(this.mode, this.currSceneIdx)
          let spine = document.getElementById('spinePlayer')
          if (spine){
            spine.components['spine'].play()
          }
          this.playAfter = false
          return
        }

        if (this.sound) this.sound.play()
        //if (this.vid) this.vid.play()
        let spine = document.getElementById('spinePlayer')
        if (spine){
          spine.components['spine'].play()
        }
      }
    },
    muted(val){
      if (!val){
        this.sound.muted = false
      }else{
        this.sound.muted = true
      }
    },
    mode(val){
      //this.playSoundFromStart(val, this.currSceneIdx)
      //this.playSoundFromStartDelay(this.mode, val, 3200)
      this.stopPlay(this.mode, val)
    },
    currSceneIdx(val){
      //console.log(val)
      this.stopPlay(this.mode, val)
      //this.playSoundFromStart(this.mode, val)
      //this.playVidFromStart(val)
      //this.playSoundFromStartDelay(this.mode, val, 2200)

    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.av-player
  display: none
  //z-index: 70



</style>
